import React from 'react';
import 'bootstrap/dist/css/bootstrap.css?rnd=61';
import image1 from './InstructionCard3.svg'
import image2 from './InstructionCard2.svg'
import image3 from './InstructionCard1.svg'
import InstructionCard from './instruction-card';
function InstructionsContainer() {
    let step1 = {
        image: image1,
        step: "Step 1",
        card_title: "Fill out the form above:",
        card_text: "Complete the form on this page. This offer is valid only for customers that bought the product at full price, on our Official Seller Account on Amazon.com. Each household is allowed a maximum of one $5 gift card. You cannot claim multiple times - even if you make multiple purchases from Meg & Hugo."
    };
    let step2 = {
        image: image2,
        step: "Step 2",
        card_title: "We Check Your Order:",
        card_text: "After you have submitted the above form, we will verify your order number for eligiblility. To be eligible your household must not have claimed the gift card previously, and your order must not have been purchased without a discount."
    };
    let step3 = {
        image: image3,
        step: "Step 3",
        card_title: "Email Confirmation",
        card_text: "If you qualify for this offer, we will send you an email to confirm your email address within 4 days. Simply reply and we will send you a $5 Amazon Gift Card via email!"
    };
    return (
        <div id='instruction-row' className='row'>
            {/* <div className='col-2 mx-auto'>
            <div className='accordion accordion-flush' >
                <div className='accordion-item'>
                    <h1 className='accordion-header mx-auto' id='headingOne'>
                        <button id='instructions-accordion' className="accordion-button collapsed text-center mx-auto" type="button" data-bs-toggle="collapse" data-bs-target="#collapseOne" aria-expanded="false" aria-controls="collapseOne">
                            How it works ↓
                        </button>
                    </h1>
                </div>
                </div>
                </div> */}
                {/* <div id='collapseOne' aria-labelledby='headingOne' className=''> */}
                <div className='instructions-container container-fluid'>
                    <div className='col px-4 instructions-card'>
                        <div className='row instructions-header-row'>
                            <h1 className='text-center text-dark instruction-header pt-4 pb-4'>How to Claim your $5 Amazon Gift Card:</h1>
                        </div>
                        <div className='row pb-3 instruction-row'>
                            <div className='col-lg-4 col-md-10 offset-md-1 col-sm-12 mx-auto py-3 px-3'>
                                <InstructionCard step={step1} />
                            </div>
                            <div className='col-lg-4 col-md-10 offset-md-1 col-sm-12 mx-auto py-3 px-3'>
                                <InstructionCard step={step2} />
                            </div>
                            <div className='col-lg-4 col-md-10 offset-md-1 col-sm-12 mx-auto py-3 px-3'>
                                <InstructionCard step={step3} />
                            </div>
                        </div>

                    </div>
                </div>
            {/* </div> */}
            </div>
       
    );
}

export default InstructionsContainer